export default __webpack_public_path__ + "static/media/TeamsNewActive.41f830d6.svg";